<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{$route.meta.title}}</h3>

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>活动管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"></el-table-column>
        <el-table-column prop="admin_name"
                         label="添加人"></el-table-column>
        <el-table-column prop="description"
                         label="描述"></el-table-column>
        <el-table-column prop="created_at"
                         label="添加时间"></el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>


<script>
import table from '@core/mixins/table'



export default {
  mixins: [table],



  data () {
    return {
      table: [],
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      search: {
        prizeid: this.$route.params.id,
      },
      // 搜索字段申明
      searchFieldType: {
        prizeid: Number,
      },
    }
  },



  computed: Vuex.mapState({}),



  created () {
  },



  methods: {
    ...Vuex.mapActions([]),


    getTableData (params) {
      return request.page('getFairPrizeLogList', params)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/fair-prize/pages/FairPrizeLogIndex.vue